"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _nuiIntl = require("@concur/nui-intl");

!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./style/ReadMore.css") : void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReadMore = function ReadMore(_ref) {
  var text = _ref.text,
      isExpanded = _ref.isExpanded,
      expand = _ref.expand;

  var clickHandler = function clickHandler(e) {
    e.preventDefault();
    expand();
  };

  var renderExpandLink = function renderExpandLink() {
    return _react.default.createElement("a", {
      href: "#",
      className: "cnqr-muted",
      onClick: clickHandler
    }, isExpanded ? _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "ReadLess"
    }) : _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "ReadMore"
    }));
  };

  var lines = text && text.split(/\r\n|\r|\n/g).length;

  var getMaxHeight = function getMaxHeight() {
    if (text && text.length < 293) {
      if (lines > 3) {
        return {
          maxHeight: "".concat(lines * 18.5714, "px") // 18.5714 is the computed linehieght

        };
      }
    }
  };

  var renderButton = function renderButton() {
    if (text && (text.length > 293 || lines > 3)) {
      return _react.default.createElement("div", {
        className: "ac-read-more ".concat(isExpanded ? 'ac-read-more-expanded' : '')
      }, renderExpandLink());
    }

    return null;
  };

  return _react.default.createElement("div", {
    className: "ac-read-more-container"
  }, _react.default.createElement("div", {
    className: "ac-read-more-text ".concat(isExpanded ? 'ac-read-more-text-expanded' : ''),
    style: getMaxHeight()
  }, text, renderButton()));
};

ReadMore.propTypes = {
  text: _propTypes.default.string.isRequired,
  isExpanded: _propTypes.default.bool.isRequired,
  expand: _propTypes.default.func.isRequired
};
var _default = ReadMore;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/listing/ReadMore.js
// module id = 259
// module chunks = 0